import { Tooltip, Typography } from '@mui/material';
import cn from 'classnames';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { AIContextSelectPopover } from '../AIContextSelectPopover';
import { AiContextFiles } from '../AIContextSelectPopover/AiContextFiles';
import { StyledActions, ToggleButton } from '../styles';
import { AIInputStateControl } from '../useAIInputState';
type Props = {
  control: AIInputStateControl;
  hideLabels?: boolean;
  disable?: boolean;
};

export const AIActionButtons = ({
  control,
  hideLabels = false,
  disable,
}: Props) => {
  const { translate } = useLocales();

  const { doSearch, think, toggleSearch, toggleThink } = control();

  return (
    <StyledActions sx={{ gap: 0.5, overflow: 'hidden', flexGrow: 1 }}>
      <Tooltip title={translate('shared.labels.search')}>
        <ToggleButton
          className={cn({ active: doSearch, disable })}
          onClick={() => {
            if (disable) return;
            toggleSearch();
          }}
        >
          <Iconify icon="tabler:world" />
          {!hideLabels && (
            <Typography variant="caption" color="text.secondary">
              {translate('shared.labels.search')}
            </Typography>
          )}
        </ToggleButton>
      </Tooltip>
      <Tooltip title={translate('copera_ai.input.think')}>
        <ToggleButton
          className={cn({ active: think, disable })}
          onClick={() => {
            if (disable) return;
            toggleThink();
          }}
        >
          <Iconify icon="tabler:universe" />
          {!hideLabels && (
            <Typography variant="caption" color="text.secondary">
              {translate('copera_ai.input.think')}
            </Typography>
          )}
        </ToggleButton>
      </Tooltip>

      <PopoverTrigger
        disabled={disable}
        popover={AIContextSelectPopover}
        context={{ control }}
      >
        <Tooltip title={translate('copera_ai.input.add_context')}>
          <ToggleButton className={cn({ disable })}>
            <Iconify icon="tabler:at" />
            {!hideLabels && (
              <Typography variant="caption" color="text.secondary">
                {translate('copera_ai.input.add_context')}
              </Typography>
            )}
          </ToggleButton>
        </Tooltip>
      </PopoverTrigger>
      <AiContextFiles control={control} />
    </StyledActions>
  );
};
